import React, { useContext, useState, useRef } from 'react';
import { dataStore } from 'store/data';
import { appStore } from 'store/app';
import styled, { createGlobalStyle } from 'styled-components';
import Selector from '../Selector/index';
import ui from 'config-app/ui';
import { CSSTransition } from 'react-transition-group';

const Component = ({ stepId, title, lead, variants, type, source }) => {

  const [dataState] = useContext(dataStore);
  const [appState] = useContext(appStore);
  const products = dataState[source].products;
  const sizes = dataState[source];
  const nodeRef = useRef(null);
  const [isActive, setIsActive] = useState(false);
  // 現在選択されている ID を取得
  const productId = appState.steps[stepId].id;
  // 現在選択されているサイズを取得
  const sizeId = appState.customData.bottle.size;

  const openModal = () => {
    setIsActive(true);
  };
  const closeModal = () => {
    setIsActive(false);
  };

  return (
    <Container>
      <Label>
        <div className="step">STEP {stepId + 1}.</div>
        <div className="label">{title}</div>
      </Label>
      <Button className={type}>
        {type === 'bottleSize' ? productId : type === 'bottleColor' ? products[productId].variants[sizeId].color : products[productId].name}
      </Button>
      {type === 'bottleSize' && sizes[productId].note && <Icon onClick={openModal}>?</Icon>}
      {type !== 'bottleSize' && products[productId].note && <Icon onClick={openModal}>!</Icon>}
      <SelectorContainer ref={nodeRef}>
        <Selector
          stepId={stepId}
          lead={lead}
          variants={variants}
          type={type}
          source={source}
        />
      </SelectorContainer>
       <CSSTransition
        in={isActive}
        timeout={300}
        unmountOnExit
      >
        <ModalContainer>
          <ModalBg />
          <Modal>
            <CloseBtn onClick={closeModal} />
              <div>
                {type === 'bottleColor' && <span style={{whiteSpace :"pre-line"}}>{products[productId].note}</span>}
                {type === 'bottleSize' && <span dangerouslySetInnerHTML={{__html: sizes[productId].note}}></span>}
                {type === 'image' && <div dangerouslySetInnerHTML={{__html: products[productId].note}}></div>}
                {type === 'color' && <div dangerouslySetInnerHTML={{__html: products[productId].note}}></div>}
            </div>
          </Modal>
          <BodyScrollLock />
        </ModalContainer>
      </CSSTransition>
    </Container>
  );

};

export default Component;


const Container = styled.div`
  ${ui.MQ_MD_LG} {
    position: relative;
  }

  ${ui.MQ_XS_SM} {
    position: relative;
    display: flex;
    flex-wrap: wrap;
  }
`;

const Label = styled.div`
  display: inline-block;

  .step {
    display: inline-block;
    white-space: nowrap;
  }

  .label {
    display: inline-block;
    margin-left: .3em;
  }
  ${ui.MQ_MD_LG} {
    font-size: 18px;
    .step {
      margin-top: 40px;
    }
  }

  ${ui.MQ_XS_SM} {
    display: flex;
    flex-wrap: wrap;
    .step {
      order: 1;
    }
    .label {
      order: 2;
    }
  }
`;

const Button = styled.div`
  font-weight: bold;
  ${ui.MQ_MD_LG} {
    display: inline;
    font-size: 18px;
    &::before {
      content: '：';
    }
  }
  ${ui.MQ_XS_SM} {
    width: 100%;
    order: 2;
    &.bottleSize {
      display: none;
    }
  }
`;

const SelectorContainer = styled.div`
      &.enter {
        opacity: 0;
      }

      &.enter-active {
        opacity: 1;
        transition: opacity 300ms;
      }

      &.exit {
        opacity: 1;
      }

      &.exit-active {
        opacity: 0;
        transition: opacity 300ms;
      }

  ${ui.MQ_MD_LG} {
  }
  ${ui.MQ_XS_SM} {
    width: 100%;
    order: 4;
  }
`;

const CloseBtn = styled.div`
  position: absolute;
  background: #333333;
  border-radius: 40px;
  &::before,
  &::after {
    content: '';
    background: #fff;
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform-origin: left top;
  }
  &::before {
    transform: rotate(-45deg) translate(-50%, -50%);
  }
  &::after {
    transform: rotate(45deg) translate(-50%, -50%);
  }
  ${ui.MQ_MD_LG} {
    cursor: pointer;
    width: 40px;
    height: 40px;
    top: 30px;
    right: 30px;
    &::before,
    &::after {
      height: 2px;
      width: 20px;
    }
  }
  ${ui.MQ_XS_SM} { 
    width: 30px;
    height: 30px;
    top: 20px;
    right: 20px;
    &::before,
    &::after {
      height: 2px;
      width: 15px;
    }
  }
`

const ModalContainer = styled.div`
  display: none;
  &.enter-done {
    display: block;
  }
`

const ModalBg = styled.div`
  content: '';
  position: fixed;
  width: 100vw;
  top: 0;
  left: 0;
  height: 100vh;
  background: rgba(28, 28, 28, .7);
  z-index: 10000;
`

const Modal = styled.div`
  top: 50%;
  left: 50%;
  box-sizing: border-box;
  background: #fff;
  z-index: 10001;
  position: fixed;
  transform: translate(-50%, -50%);

  .product-single__variation__select__caution  {
    > div{
      display: inline-block;
    }
    & + .product-single__variation__select__caution {
      margin-top: 5px;
    }
  }
  ${ui.MQ_XS_SM} {
    width: calc(100vw - 30px);
    padding: 65px 20px 30px;
    line-height: 20px;
  }


  ${ui.MQ_MD_LG} {
    width: 800px;
    padding: 90px 50px 50px;
    line-height: 32px;
  }
`;

const Icon = styled.span`
  display: inline-block;
  vertical-align: middle;
  background: #888888;
  color: #fff;
  font-weight: bold;
  border-radius: 50%;
  text-align: center;
  height: 18px;
  width: 18px;
  margin-left: 10px;
  line-height: 17px;
  ${ui.MQ_MD_LG} {
    font-size: 14px;
    vertical-align: 4%;
    cursor: pointer;
  }
  ${ui.MQ_XS_SM} { 
  
  }
`;

const BodyScrollLock = createGlobalStyle`
  html {
    overflow: hidden;
  }
  body {
    overflow: scroll;
  }
`;
